var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['justify-content-center', _vm.show ? 'd-flex' : 'd-none']},[_c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.__('alert.loading')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }